import styled from 'styled-components';

export const Blocker = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
`;

export const Container = styled.div`
  position: relative;
`;

export const Content = styled.div`
  z-index: 1;
`;
